var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid-x grid-margin-x text-center" }, [
    _c("div", { staticClass: "cell medium-3" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("v-select-kolonne", {
            attrs: {
              id: "form-field-kolonne",
              name: "kolonne",
              placeholder: _vm.$t("select_all"),
            },
            model: {
              value: _vm.item.kolonne,
              callback: function ($$v) {
                _vm.$set(_vm.item, "kolonne", $$v)
              },
              expression: "item.kolonne",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cell medium-3" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("v-datepicker", {
            staticClass: "form-control form-control--small form-control--date",
            attrs: {
              placeholder: _vm.$t("search.from"),
              format: _vm.$t("search.from") + " " + _vm.$helpers.dateFormat,
              clearButton: true,
              "monday-first": true,
              "disabled-dates": _vm.$helpers.disabledDates,
              language: _vm.de,
            },
            model: {
              value: _vm.item.startdate,
              callback: function ($$v) {
                _vm.$set(_vm.item, "startdate", $$v)
              },
              expression: "item.startdate",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cell medium-3" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("v-datepicker", {
            staticClass: "form-control form-control--small form-control--date",
            attrs: {
              placeholder: _vm.$t("search.till"),
              format: _vm.$t("search.till") + " " + _vm.$helpers.dateFormat,
              clearButton: true,
              "monday-first": true,
              "disabled-dates": {
                days: [6, 0],
                to: new Date(_vm.item.startdate),
              },
              language: _vm.de,
            },
            model: {
              value: _vm.item.enddate,
              callback: function ($$v) {
                _vm.$set(_vm.item, "enddate", $$v)
              },
              expression: "item.enddate",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cell medium-3" }, [
      _c(
        "button",
        {
          staticClass: "button button--save button--small",
          class: [_vm.savesuccess ? "u-animated-saved" : ""],
          attrs: { role: "button", title: _vm.$t("form.submit.save") },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.saveEntry(_vm.item)
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("form.submit.save")))]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button button--delete",
          attrs: { role: "button", title: _vm.$t("delete") },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.deleteEntry(_vm.item)
            },
          },
        },
        [_vm._v("X")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }